import { render, staticRenderFns } from "./modulePermissons.vue?vue&type=template&id=cb776062&scoped=true&lang=html&"
import script from "./modulePermissons.vue?vue&type=script&lang=js&"
export * from "./modulePermissons.vue?vue&type=script&lang=js&"
import style0 from "./modulePermissons.vue?vue&type=style&index=0&id=cb776062&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb776062",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VDataTable,VFlex,VSelect})
